import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import MobileMenu from './MobileMenu';
import { companyInfo } from '../data/companyInfo';

function HeaderOne() {
    const [isSticky, setIsSticky] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { pathname } = useLocation();

    const isHomeActive = pathname === '/';
    const isAboutActive = pathname === '/about';
    const isDestinationActive = pathname.startsWith('/destination');
    const isTourActive = pathname.startsWith('/tour');
    const isContactActive = pathname === '/contact';

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            {/*============================== Header Area ==============================*/}
            <header className="th-header header-layout1">
                <div className="header-top">
                    <div className="container th-container">
                        <div className="row justify-content-center justify-content-xl-between align-items-center">
                            <div className="col-auto d-none d-md-block">
                                <div className="header-links">
                                    <ul>
                                        <li className="d-none d-xl-inline-block">
                                            <i className="fa-sharp fa-regular  fa-location-dot" />
                                            <span>{companyInfo.addressShort}</span>
                                        </li>
                                        <li className="d-none d-xl-inline-block">
                                            <i className="fa-regular fa-clock" />
                                            <span>24/7 Available</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="header-right">
                                    <div className="header-links">
                                        <ul>
                                            <li className="d-none d-md-inline-block">
                                                <Link to="/faq">FAQ</Link>
                                            </li>
                                            <li className="d-none d-md-inline-block">
                                                <Link to="/contact">Support</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
                    {/* Main Menu Area */}
                    <div className="menu-area">
                        <div className="container th-container">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto">
                                    <div className="header-logo">
                                        <Link to="/">
                                            <img src="/assets/img/logo-white.png" alt="Himolan Peak Adventures" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-auto me-xl-auto">
                                    <nav className="main-menu d-none d-xl-inline-block">
                                        <ul>
                                            <li>
                                                <Link className={isHomeActive ? 'active' : ''} to="/">
                                                    Home
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className={isAboutActive ? 'active' : ''} to="/about">About Us</Link>
                                            </li>
                                            <li>
                                                <Link className={isDestinationActive ? 'active' : ''} to="/destination">Destination</Link>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <Link className={isTourActive ? 'active' : ''} to="/tour">Our Tour</Link>
                                                <ul className="sub-menu">
                                                    <li>
                                                        <Link to="/tour">All Tours</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/tour/skardu-blossom-tour">Skardu Blossom Tour (By Road)</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/tour/skardu-tour-by-air">Skardu Tour (By Air)</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/tour/skardu-honeymoon-special">Skardu Honeymoon Special</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/tour/hunza-cherry-blossom-tour">Hunza Cherry Blossom Tour</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/tour/hunza-nagar-naltar-tour">Hunza, Nagar & Naltar (By Road)</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/tour/fairy-meadows-hunza-tour">Fairy Meadows & Hunza Tour</Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <Link className={isContactActive ? 'active' : ''} to="/contact">Contact us</Link>
                                            </li>
                                        </ul>
                                    </nav>
                                    <button
                                        type="button"
                                        className="th-menu-toggle d-block d-xl-none"
                                        onClick={() => setIsMobileMenuOpen(true)}
                                    >
                                        <i className="far fa-bars" />
                                    </button>
                                </div>
                                <div className="col-auto d-none d-xl-block">
                                    <div className="header-button">
                                        <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style3 th-icon">
                                            Book Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="logo-bg bg-mask"
                            style={{
                                WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                                maskImage: "url(/assets/img/logo_bg_mask.png)"
                            }} />
                    </div>
                </div>
            </header>
            <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
        </>

    )
}
export default HeaderOne


